import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

/**
 * Loading placeholder.
 *
 * `aria-hidden` because a screen reader announcing a dozen empty boxes is
 * noise — the live region on the containing view announces "loading" once.
 */
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      aria-hidden="true"
      className={cn('animate-pulse rounded-md bg-muted', className)}
      {...props}
    />
  );
}
